import { CircularProgressBar } from "@mdotm/shadcn/legacy/components";
import { toClassName, type ClassList, toClassListRecord } from "@mdotm/shadcn/legacy/react-extensions";
import type { CSSProperties } from "react";

export type InfiniteLoaderProps = {
	className?: ClassList;
	style?: CSSProperties;
};

const InfiniteLoader = ({ style, className }: InfiniteLoaderProps): React.JSX.Element => {
	return (
		<div
			className={toClassName({ "h-full flex items-center justify-center": true, ...toClassListRecord(className) })}
			style={style}
		>
			<CircularProgressBar value="indeterminate" style={{ width: 42 }} />
		</div>
	);
};

export default InfiniteLoader;
